import React, {useMemo, useState} from "react";
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import EvaliationFinishService from "services/EvaluationFinishService";
import {connect} from "react-redux";
import Button from "components/Button";
import Tr from 'translations/Translations'
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import {makeStyles} from "@material-ui/core";
import LoadingScreen from "components/complex/loadingScreen/LoadingScreen";
import RouterPath from "libs/RouterPath";
import Icon from '@material-ui/icons/CheckBox'
import IconOff from '@material-ui/icons/HighlightOff';

const useStyle = makeStyles((theme) => ({
    button: {
        marginTop: theme.spacing(2)
    },
    text: {
        marginTop: theme.spacing(4)
    },
    icon: theme.components.icon,
}))

const rp = RouterPath.myProcedure;

function StageFinish(
    {
        match,
        demandValidation
    }) {
    const classes = useStyle();
    const id = match.params.id;
    const curDemandValidation = DemandValidation.STAGE_FINISH;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const prevErrors = useMemo(() => demandValidation.filter((x) => x.section !== curDemandValidation && x.status === 'ERROR'), [demandValidation, curDemandValidation]);
    const [working, setWorking] = useState(false)

    const goToFinish = () => {
        setWorking(true);
        EvaliationFinishService.doFinishEvaluation(id).finally(() => setWorking(false)).then((resp) => {
            if (resp.success) {
                if (resp.result) {
                    window.location.href = resp.result;
                } else {
                    RouterPath.redirect(RouterPath.createPath(rp.steps.MP_4_ID, {id: id}))
                }
            }
        });
    }

    const hasPrevErrors = prevErrors.length > 0;
    return (<GridBlock
            direction='column'
            alignItems='center'
        >
            {hasPrevErrors ?
                <IconOff className={classes.icon} color='primary'/>
                :
                <Icon className={classes.icon} color='primary'/>
            }
            {hasPrevErrors ?
                <Typography>{Tr('to_finish_stage_done_sections')}: "{prevErrors.map((x) => Tr(DemandValidationKeys[x.section])).join("\", \"")}"</Typography>
                :
                <Typography>{Tr('go_to_stage_finishing_info')}</Typography>
            }
            <Button className={classes.button}
                    disabled={hasPrevErrors || !section.editable || section.status !== 'ERROR'}
                    onClick={goToFinish}>
                {Tr('primary_tender_variant_make_negociation')}
            </Button>
            <LoadingScreen open={working}/>
        </GridBlock>
    )
}

StageFinish.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation
}), {})(withRouter(StageFinish));